const changelog = [
  {
    title:
      "Add deprecation warning, link to new documentation",
    date: "2024-02-20",
    description:
      "Client Portal API documentation on Github is now deprecated, please see new docs on the IBKR Campus.",
    changes: [
      "Added deprecation warning to home page",
      "Addedd link to new documentation",
    ],
    tags: ["documentation"],
  },
  {
    title:
      "Remove support for fractional share orders, new act websocket topic",
    date: "2023-08-28",
    description:
      "Remove references to fractional share orders, add information about new act websocket topic",
    changes: [
      "Removed references to fractional share orders from the documentation - fractional share orders are no longer supported",
      "Added information about the new unsolicited act websocket topic",
      "Fixed some visual bugs in documentation",
      "Removed references to deprecated docs page",
    ],
    tags: ["documentation", "endpoints", "websockets"],
  },
  {
    title: "New gateway release, swagger updates",
    date: "2023-04-27",
    description:
      "Updated Swagger documentation, added link for new API gateway release",
    changes: [
      'Removed required status for "since" field in the /marketdata/snapshot endpoint',
      'Added optional "startTime" parameter to the /marketdata/history endpoint',
      "Fixed incorrectly formatted params in alert URLs in Swagger files",
      "Added missing type query parameter to the /alert/{id} endpoint",
      "Updated download links for API gateway to latest version",
      'Added information on using <a href="./use-cases#beta-endpoints">Beta endpoints</a> to Use Cases page',
      "Added new tags 7920 (Daily PnL) and 7921 (Cost Basis) for market data snapshot endpoints",
      "Minor wording and code updates",
    ],
    tags: ["documentation", "endpoints", "authentication"],
  },
  {
    title: "General documentation updates",
    date: "2023-01-11",
    description:
      "Updated information about authentication methods for institutional clients, general formatting and readability updates",
    changes: [
      "Updated authentication information for institutional clients",
      "Updated websockets topics to use quotation marks instead of apostrophes",
      'Added information about placing <a href="./use-cases#combo-orders">combo orders</a> in Client Portal API',
      "General wording updates",
    ],
    tags: ["documentation", "websockets", "authentication"],
  },
  {
    title: "Added authentication information for institutional clients",
    date: "2022-09-30",
    description: "Added authentication information for institutional clients",
    changes: [
      "Added information about authentication methods for institutional clients",
      "Added required attributes to the market data snapshot request",
      "Renamed Workflows page to Use Cases",
      "Minor visual bug fixes",
    ],
    tags: ["documentation", "authentication", "endpoints"],
  },
  {
    title: "Updated list of endpoints and add minor bug fixes",
    date: "2022-09-08",
    description: "Updated swagger endpoints and minor bug fixes",
    changes: [
      "Updated list of swagger endpoints",
      "Fixed bug with institutional workflows page",
    ],
    tags: ["documentation", "endpoints"],
  },
  {
    title: "Further formatting updates",
    date: "2022-09-01",
    description:
      "Improved visual look of code samples and fixed some broken links",
    changes: [
      "Added syntax highlighting to code samples",
      "Added a copy to clipboard button to code samples",
      "Add support for landscape orientation on mobile devices",
      "Updated table styling",
      "Fixed broken links for swagger.json and references to the websockets page",
    ],
    tags: ["documentation"],
  },
  {
    title: "Added new topics and improved formatting",
    date: "2022-08-25",
    description:
      "Added new websockets, endpoints and workflows documentation and improved formatting of code examples",
    changes: [
      'New <a href="./websockets#market-depth-data">market depth topic</a> added to websockets documentation',
      "Improved formatting of code examples",
      "Added information about trailing type orders to the orders endpoint",
      'Added endpoint specific <a href="./use-cases#pacing-limitations">pacing limitations</a>',
    ],
    tags: ["documentation", "websockets", "endpoints", "workflows"],
  },
  {
    title: "New API documentation released",
    date: "2022-08-16",
    description: "New API documentation released",
    changes: [
      "Released new Client Portal API documentation",
      "Visual overhaul of the documentation UI",
      "Grouped topics into relevant sections",
      "Institutional topics are in progress and will be released during the week",
    ],
    tags: ["documentation"],
  },
];

export { changelog };
